var map = {
	"./akshare.svg": 26032,
	"./api.svg": 30747,
	"./arxiv.svg": 90854,
	"./assistant.svg": 4159,
	"./baidu-fanyi.svg": 83544,
	"./baidu.svg": 92892,
	"./begin.svg": 69779,
	"./bing.svg": 55914,
	"./cancel.svg": 8156,
	"./chat-app-cube.svg": 34339,
	"./chat-configuration-atom.svg": 57950,
	"./chat-star.svg": 49570,
	"./chunk-method/book-01.svg": 38726,
	"./chunk-method/book-02.svg": 21357,
	"./chunk-method/book-03.svg": 88093,
	"./chunk-method/book-04.svg": 58355,
	"./chunk-method/chunk-empty.svg": 16035,
	"./chunk-method/knowledge-graph-01.svg": 42576,
	"./chunk-method/knowledge-graph-02.svg": 46853,
	"./chunk-method/law-01.svg": 54530,
	"./chunk-method/law-02.svg": 75787,
	"./chunk-method/manual-01.svg": 64179,
	"./chunk-method/manual-02.svg": 40547,
	"./chunk-method/manual-03.svg": 1437,
	"./chunk-method/manual-04.svg": 81486,
	"./chunk-method/media-01.svg": 33952,
	"./chunk-method/media-02.svg": 93802,
	"./chunk-method/naive-01.svg": 88488,
	"./chunk-method/naive-02.svg": 74795,
	"./chunk-method/one-01.svg": 88533,
	"./chunk-method/one-02.svg": 99199,
	"./chunk-method/one-03.svg": 23192,
	"./chunk-method/one-04.svg": 72906,
	"./chunk-method/paper-01.svg": 64018,
	"./chunk-method/paper-02.svg": 77250,
	"./chunk-method/presentation-01.svg": 87162,
	"./chunk-method/presentation-02.svg": 59640,
	"./chunk-method/qa-01.svg": 39420,
	"./chunk-method/qa-02.svg": 55086,
	"./chunk-method/resume-01.svg": 76604,
	"./chunk-method/resume-02.svg": 96131,
	"./chunk-method/table-01.svg": 42743,
	"./chunk-method/table-02.svg": 84817,
	"./chunk-method/tag-01.svg": 96953,
	"./chunk-method/tag-02.svg": 82472,
	"./concentrator.svg": 86933,
	"./crawler.svg": 71090,
	"./database.svg": 38575,
	"./deepl.svg": 98301,
	"./delete.svg": 71483,
	"./disable.svg": 84377,
	"./duck.svg": 24287,
	"./email.svg": 10808,
	"./enable.svg": 8207,
	"./es.svg": 96492,
	"./exesql.svg": 43004,
	"./file-icon/aep.svg": 83889,
	"./file-icon/ai.svg": 28897,
	"./file-icon/avi.svg": 27635,
	"./file-icon/css.svg": 52229,
	"./file-icon/csv.svg": 50747,
	"./file-icon/dmg.svg": 71691,
	"./file-icon/doc.svg": 35354,
	"./file-icon/docx.svg": 69139,
	"./file-icon/eps.svg": 43279,
	"./file-icon/exe.svg": 46462,
	"./file-icon/fig.svg": 33179,
	"./file-icon/folder.svg": 54168,
	"./file-icon/gif.svg": 73845,
	"./file-icon/html.svg": 53682,
	"./file-icon/indd.svg": 26763,
	"./file-icon/java.svg": 13916,
	"./file-icon/jpeg.svg": 19525,
	"./file-icon/jpg.svg": 24674,
	"./file-icon/js.svg": 38470,
	"./file-icon/json.svg": 56373,
	"./file-icon/md.svg": 77357,
	"./file-icon/mkv.svg": 49197,
	"./file-icon/mp3.svg": 44538,
	"./file-icon/mp4.svg": 52038,
	"./file-icon/mpeg.svg": 77747,
	"./file-icon/pdf.svg": 82938,
	"./file-icon/png.svg": 71915,
	"./file-icon/ppt.svg": 85173,
	"./file-icon/pptx.svg": 62133,
	"./file-icon/psd.svg": 30182,
	"./file-icon/rss.svg": 38428,
	"./file-icon/sql.svg": 78501,
	"./file-icon/svg.svg": 72515,
	"./file-icon/tiff.svg": 4502,
	"./file-icon/txt.svg": 55773,
	"./file-icon/wav.svg": 63645,
	"./file-icon/webp.svg": 87260,
	"./file-icon/xls.svg": 5343,
	"./file-icon/xlsx.svg": 41475,
	"./file-icon/xml.svg": 38476,
	"./file-management.svg": 39121,
	"./github.svg": 69696,
	"./google-scholar.svg": 99466,
	"./google.svg": 18176,
	"./graph.svg": 57355,
	"./invoke-ai.svg": 82888,
	"./jin10.svg": 31801,
	"./keyword.svg": 30552,
	"./knowledge-base.svg": 87055,
	"./knowledge-configration.svg": 96450,
	"./knowledge-dataset.svg": 9385,
	"./knowledge-testing.svg": 65376,
	"./langfuse.svg": 6514,
	"./llm/anthropic.svg": 74768,
	"./llm/azure.svg": 99817,
	"./llm/baai.svg": 93594,
	"./llm/baichuan.svg": 6507,
	"./llm/bedrock.svg": 30818,
	"./llm/chat-minimax.svg": 69534,
	"./llm/cohere.svg": 86198,
	"./llm/deepseek.svg": 23476,
	"./llm/fish-audio.svg": 97300,
	"./llm/gemini.svg": 69156,
	"./llm/github.svg": 29034,
	"./llm/google-cloud.svg": 75383,
	"./llm/google.svg": 93926,
	"./llm/gpustack.svg": 41538,
	"./llm/groq-next.svg": 43719,
	"./llm/huggingface.svg": 20566,
	"./llm/hunyuan.svg": 10266,
	"./llm/jina.svg": 19765,
	"./llm/lepton-ai.svg": 68341,
	"./llm/lm-studio.svg": 77894,
	"./llm/local-ai.svg": 97354,
	"./llm/mistral.svg": 58247,
	"./llm/modelscope.svg": 21248,
	"./llm/moonshot.svg": 98184,
	"./llm/nomic-ai.svg": 14860,
	"./llm/novita-ai.svg": 72584,
	"./llm/nvidia.svg": 33325,
	"./llm/ollama.svg": 59488,
	"./llm/open-router.svg": 23258,
	"./llm/openai-api.svg": 63715,
	"./llm/openai.svg": 81459,
	"./llm/perfx-cloud.svg": 39886,
	"./llm/ppio.svg": 89957,
	"./llm/replicate.svg": 13492,
	"./llm/sentence-transformers.svg": 85448,
	"./llm/siliconflow.svg": 65762,
	"./llm/spark.svg": 4216,
	"./llm/stepfun.svg": 53618,
	"./llm/tencent-cloud.svg": 96734,
	"./llm/together-ai.svg": 65167,
	"./llm/tongyi.svg": 74296,
	"./llm/upstage.svg": 30464,
	"./llm/vllm.svg": 91333,
	"./llm/volc_engine.svg": 25210,
	"./llm/voyage.svg": 6385,
	"./llm/wenxin.svg": 34981,
	"./llm/xinference.svg": 76577,
	"./llm/yi.svg": 20447,
	"./llm/yiyan.svg": 55103,
	"./llm/youdao.svg": 81010,
	"./llm/zhipu.svg": 19568,
	"./login-avatars.svg": 68683,
	"./login-background.svg": 89624,
	"./login-star.svg": 31130,
	"./logo-with-text-white.svg": 49313,
	"./logout.svg": 67487,
	"./minio.svg": 32382,
	"./model-providers.svg": 70410,
	"./moon.svg": 22350,
	"./more-model.svg": 88458,
	"./more.svg": 1333,
	"./move.svg": 90076,
	"./mysql.svg": 37124,
	"./navigation-pointer.svg": 1979,
	"./next-login-bg.svg": 33391,
	"./note.svg": 28687,
	"./nothing.svg": 47138,
	"./paper-clip.svg": 2306,
	"./password.svg": 33530,
	"./plus-circle-fill.svg": 3804,
	"./plus.svg": 75350,
	"./profile.svg": 1769,
	"./prompt.svg": 49261,
	"./pubmed.svg": 78566,
	"./qweather.svg": 56077,
	"./redis.svg": 43867,
	"./refresh.svg": 96198,
	"./resize.svg": 80415,
	"./run.svg": 91449,
	"./select-files-end.svg": 14387,
	"./select-files-start.svg": 16734,
	"./selected-files-collapse.svg": 40975,
	"./storage.svg": 3949,
	"./switch.svg": 1311,
	"./team.svg": 52381,
	"./template.svg": 63993,
	"./translation.svg": 40724,
	"./tushare.svg": 16521,
	"./wencai.svg": 72835,
	"./wikipedia.svg": 18684,
	"./yahoo-finance.svg": 7957
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78131;